const getFunLinkSdk = () => {
  const sdk = window.FUN_LINK_SDK;

  if (!sdk || typeof sdk.getOmniPositionData !== 'function') {
    throw new Error('Fun Link SDK 未加载或版本低于 0.2.x');
  }

  return sdk;
};

const validateOmniResponse = (result, fallbackMessage) => {
  if (!result || result.status !== 0 || !result.data) {
    throw new Error(result?.msg || fallbackMessage);
  }

  return result;
};

/**
 *  获取omni数据
 * @param {*} position 分发位置
 * @returns
 */
export async function getOmniData(position) {
  const result = await getFunLinkSdk().getOmniPositionData({
    param: {
      lang: 'zh-Hans',
      positions: [{ position, dataSources: [] }]
    },
    format: ''
  });

  return validateOmniResponse(result, '获取 OMNI 数据失败').data[position];
}

export const ominStaticResPos = {
  // 首页-阶段下载链接相关信息
  home_downloadDefault: { position: 'channel_cat_719a2070', dataSources: [{ dataSourceId: 'ds_cat_1717631d' }] },
  // 首页-阶段下载链接相关信息，根据 地址栏链接来获得不同的配置链接
  home_downloadCustom: {
    position: 'channel_cat_719a2070',
    dataSources: [
      {
        dataSourceId: 'ds_cat_9d2c0342',
        contentFilter: { relation: 'and', items: [{ field: 'utm_source', operator: 'eq', value: '' }] }
      }
    ]
  },
  // 首页-游戏阶段相关信息
  home_downloadStage: { position: 'channel_cat_719a2070', dataSources: [{ dataSourceId: 'ds_cat_b5d304c1' }] },
  // 第五屏-下载页链接
  attentionDownload: { position: 'channel_cat_719a2070', dataSources: [{ dataSourceId: 'etlv48ph' }] },
  // 首屏KV
  home_kv: { position: 'channel_cat_719a2070', dataSources: [{ dataSourceId: 'ds_cat_902f15b5' }] },
  // 首页-活动规则弹窗
  activityRule: { position: 'channel_cat_719a2070', dataSources: [{ dataSourceId: 'etlrbufc' }] },

  // 公测活动页
  publicBeta: { position: 'channel_cat_9a2070fd', dataSources: [{ dataSourceId: 'ds_cat_bac4c3a5' }] },
  // 游戏特色轮播数据
  characteristics: { position: 'channel_cat_f08e881b', dataSources: [{ dataSourceId: 'ds_cat_b894ce49' }] },
  // 门派数据
  introduced: { position: 'channel_cat_70fda197', dataSources: [{ dataSourceId: 'ds_cat_d8be938d' }] }
};

export async function getOmniPosData(positions) {
  const result = await getFunLinkSdk().getOmniPositionData({
    param: { lang: 'zh-Hans', positions },
    format: 'ds'
  });

  return validateOmniResponse(result, '获取 OMNI 分发数据失败');
}
